import Entity from "../../../class/abstract/Entity";
import License from "../../_account/Licenses/License";
import AutomaticDrawer from "./AutomaticDrawer";

class AutomaticDrawerLicense extends Entity {
    automatic_drawer_id = null;
    drawer = {};
    license_id = null;
    license = {};

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        var keys = Object.keys(this);
        var key = "";

        for(var i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                if(key === "drawer")
                    Reflect.set(this, key, new AutomaticDrawer(datas[key]));
                else if(key === "license")
                    Reflect.set(this, key, new License(datas[key]));
                else
                    Reflect.set(this, key, datas[key]);
            }
        }
    }
}

export default AutomaticDrawerLicense;
